import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card shadow" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-s-order fs-2 text-dark" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "d-flex justify-content-between items-center gap-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Хайх")
const _hoisted_9 = { style: {"margin-top":"10px","text-align":"center"} }

import { computed, onMounted } from "vue";
import { useLogTable } from "@/composables/useLogTable";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    endpoint: null,
    columns: null,
    show: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  endpoint: string;
  columns: Array<{
    prop: string;
    label: string;
    width?: number;
    sortable?: boolean;
  }>;
  show?: {
    org?: boolean;
    ip?: boolean;
    method?: boolean;
    provider?: boolean;
    branch?: boolean;
    patch?: boolean;
  };
}



onMounted(() => {
  setCurrentPageTitle("Лог бүртгэл"); // 👈 here
});

const show = computed(() =>
  Object.assign(
    {
      org: false,
      ip: false,
      method: false,
      provider: false,
      branch: false,
      patch: false
    },
    props.show || {}
  )
);
const {
  loading,
  rows,
  total,
  page,
  pageSize,
  sortBy,
  sortDir,
  dateRange,
  text,
  username,
  orgcode,
  clientIp,
  method,
  providerRegnum,
  providerBranch,
  patchId,
  fetch,
  onSort,
  onPage,
  onPageSize,
  shortcuts
} = useLogTable(props.endpoint);

onMounted(fetch);

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("b", null, _toDisplayString(__props.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_date_picker, {
          modelValue: _unref(dateRange),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dateRange) ? (dateRange).value = $event : null)),
          type: "daterange",
          size: "mini",
          "unlink-panels": "",
          "start-placeholder": "Эхлэх",
          "end-placeholder": "Дуусах",
          shortcuts: _unref(shortcuts),
          onChange: _unref(fetch)
        }, null, 8, ["modelValue", "shortcuts", "onChange"]),
        _createVNode(_component_el_input, {
          modelValue: _unref(text),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(text) ? (text).value = $event : null)),
          size: "mini",
          placeholder: "Хайлт...",
          style: {"width":"220px"},
          onKeyup: _withKeys(_unref(fetch), ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        _createVNode(_component_el_input, {
          modelValue: _unref(username),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(username) ? (username).value = $event : null)),
          size: "mini",
          placeholder: "Хэрэглэгч",
          style: {"width":"160px"},
          onKeyup: _withKeys(_unref(fetch), ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        (_unref(show).org)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              modelValue: _unref(orgcode),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(orgcode) ? (orgcode).value = $event : null)),
              size: "mini",
              placeholder: "Байгууллага",
              style: {"width":"140px"},
              onKeyup: _withKeys(_unref(fetch), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]))
          : _createCommentVNode("", true),
        (_unref(show).ip)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 1,
              modelValue: _unref(clientIp),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(clientIp) ? (clientIp).value = $event : null)),
              size: "mini",
              placeholder: "IP",
              style: {"width":"140px"},
              onKeyup: _withKeys(_unref(fetch), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]))
          : _createCommentVNode("", true),
        (_unref(show).method)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 2,
              modelValue: _unref(method),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(method) ? (method).value = $event : null)),
              size: "mini",
              placeholder: "Method",
              style: {"width":"120px"},
              onKeyup: _withKeys(_unref(fetch), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]))
          : _createCommentVNode("", true),
        (_unref(show).provider)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 3,
              modelValue: _unref(providerRegnum),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(providerRegnum) ? (providerRegnum).value = $event : null)),
              size: "mini",
              placeholder: "Нийлүүлэгч",
              style: {"width":"130px"},
              onKeyup: _withKeys(_unref(fetch), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]))
          : _createCommentVNode("", true),
        (_unref(show).branch)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 4,
              modelValue: _unref(providerBranch),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(providerBranch) ? (providerBranch).value = $event : null)),
              size: "mini",
              placeholder: "Салбар",
              style: {"width":"130px"},
              onKeyup: _withKeys(_unref(fetch), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]))
          : _createCommentVNode("", true),
        (_unref(show).patch)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 5,
              modelValue: _unref(patchId),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(patchId) ? (patchId).value = $event : null)),
              size: "mini",
              placeholder: "Patch ID",
              style: {"width":"110px"},
              onKeyup: _withKeys(_unref(fetch), ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_input_number, {
          modelValue: _unref(pageSize),
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : null)),
          min: 5,
          max: 100,
          size: "mini",
          onChange: _cache[10] || (_cache[10] = n => _unref(onPageSize)(n))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          icon: "el-icon-search",
          size: "mini",
          onClick: _unref(fetch)
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: _unref(rows),
        size: "mini",
        border: "",
        "default-sort": {
          prop: _unref(sortBy),
          order: _unref(sortDir) === 'asc' ? 'ascending' : 'descending'
        },
        onSortChange: _unref(onSort),
        style: {"margin-top":"10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            width: "50",
            label: "№"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (c) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: c.prop,
              prop: c.prop,
              label: c.label,
              width: c.width || null,
              sortable: c.sortable !== false
            }, null, 8, ["prop", "label", "width", "sortable"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "default-sort", "onSortChange"])), [
        [_directive_loading, _unref(loading)]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_pagination, {
          layout: "total, prev, pager, next, jumper",
          total: _unref(total),
          "page-size": _unref(pageSize),
          "current-page": _unref(page),
          onCurrentChange: _unref(onPage)
        }, null, 8, ["total", "page-size", "current-page", "onCurrentChange"])
      ])
    ])
  ]))
}
}

})